// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"th_a bhy_b bhy_bj","SubscribedPhotoblogs__link":"th_b bhy_a bhy_r"};